import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import {
  AppCheck,
  AppCheckTokenResult,
  getToken,
} from '@angular/fire/app-check';
import { catchError, from, Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';

@Injectable()
export class AppCheckInterceptor implements HttpInterceptor {
  private readonly appCheck = inject(AppCheck);
  // App Check debug token :
  // https://console.firebase.google.com/u/0/project/paillardes-et-chants/appcheck/apps
  public intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    return from(getToken(this.appCheck)).pipe(
      // keepUnstableUntilFirst, // maybe uncomment when ngUniversal
      take(1), // See https://stackoverflow.com/a/60196923/828547.
      switchMap((token: AppCheckTokenResult | undefined) => {
        let req = request;
        if (token) {
          req = request.clone({
            setHeaders: { 'X-Firebase-AppCheck': token.token },
          });
        }
        return next.handle(req);
      }),
      catchError((error: Error) => {
        console.error(error.message);
        return next.handle(request);
      }),
    );
  }
}
